module.exports = __webpack_public_path__ + "media/images/icons/twitter-3dfe78db7cd35f2435d7244ad1a3c490.svg";